import { html, LitElement } from 'lit-element'
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';


export default class commonHeroFeatures extends LitElement {
  static get properties() {
    return {
      featurePaths: {type: Object},
      swatches: {type: Object},
      productFeatures: {type: Object},
      productUrl: {type: String},
      productType: {type: String},
      productTypeName: {type: String},
      productStyle: {type: String},
    }
  }

  constructor() {
    super();
  }

  // to enable global CSS, turning off shadow Root
  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback()
  }
  
  render() {
    this.videos = this.featurePaths[this.productStyle].videos;
    return html`
        <div class="carousal feature-card-content">
          <div class="carousal-slide feature-card-wrapper">
            <div class="card">
              <div class="picture">
                ${this.videos ?
                  html`<video poster="${this.videos.one.cover}" src="${this.videos.one.mp4}" playsinline autoplay preload="auto" loop muted disableRemotePlayback>
                    <source src="${this.videos.one.mp4}" type="video/mp4" />
                  </video>`
                  :
                  html`<img src="${this.featurePaths[this.productStyle].images.one}"/>`
                }
              </div>
              <div class="absolute-block feature-details">
                <p class="title footnote">${unsafeHTML(this.productFeatures.feature_title_1)}</p>
                <h2 class="serif para">${unsafeHTML(this.productFeatures.feature_tagline_1)}</h2>
              </div>
            </div>
          </div>
          <div class="carousal-slide feature-card-wrapper">
            <div class="card">
              <div class="picture">
              ${this.productType === 'knit-polo' && this.videos ? 
                html`<img src="${this.videos.two.cover}"/>` 
                : 
                (this.videos ? 
                  html`<video poster="${this.videos.two.cover}" src="${this.videos.two.mp4}" playsinline autoplay preload="auto" loop muted disableRemotePlayback>
                    <source src="${this.videos.two.mp4}" type="video/mp4" />
                  </video>` 
                  : 
                  html`<img src="${this.featurePaths[this.productStyle].images.two}"/>`
                )
              }
              </div>
              <div class="absolute-block feature-details">
                <p class="title footnote">${unsafeHTML(this.productFeatures.feature_title_2)}</p>
                <h2 class="serif para">${unsafeHTML(this.productFeatures.feature_tagline_2)}</h2>
              </div>
            </div>
          </div>
          <div class="carousal-slide feature-card-wrapper">
            <div class="card">
              <div class="picture">
                ${this.productType === 'knit-polo' && this.videos ? 
                  html`<img src="${this.videos.three.cover}"/>` 
                  : 
                  (this.videos ? 
                    html`<video poster="${this.videos.three.cover}" src="${this.videos.three.mp4}" playsinline autoplay preload="auto" loop muted disableRemotePlayback>
                      <source src="${this.videos.three.mp4}" type="video/mp4" />
                    </video>` 
                    : 
                    html`<img src="${this.featurePaths[this.productStyle].images.three}"/>`
                  )
                }
              </div>
              <div class="absolute-block feature-details">
                <p class="title footnote">${unsafeHTML(this.productFeatures.feature_title_3)}</p>
                <h2 class="serif para">${unsafeHTML(this.productFeatures.feature_tagline_3)}</h2>
              </div>
            </div>
          </div>
          <div class="carousal-slide spacer-slide">
          </div>
        </div>`;
  }
}

customElements.define('common-hero-features', commonHeroFeatures);
